import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function PaginationBar({ totalItems, pageSize, setPageSize, currentPage, totalPages, setCurrentPage, testIdSuffix = "" }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between px-1 gap-2">
      <div className="flex items-center gap-2 text-sm text-slate-500 flex-wrap">
        <span>{totalItems} document(s)</span>
        <span className="text-slate-300 hidden sm:inline">|</span>
        <span className="hidden sm:inline">Afficher</span>
        <select className="border border-slate-200 rounded px-2 py-1 text-sm bg-white" value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setCurrentPage(1); }} data-testid={`page-size-select${testIdSuffix}`}>
          <option value={20}>20</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
        </select>
      </div>
      <div className="flex items-center gap-1 self-end sm:self-auto">
        <Button variant="outline" size="sm" className="h-8 w-8 p-0" disabled={currentPage <= 1} onClick={() => setCurrentPage(p => p - 1)} data-testid={`page-prev${testIdSuffix}`}><ChevronLeft size={14} /></Button>
        <span className="text-sm text-slate-600 px-2">{currentPage} / {totalPages}</span>
        <Button variant="outline" size="sm" className="h-8 w-8 p-0" disabled={currentPage >= totalPages} onClick={() => setCurrentPage(p => p + 1)} data-testid={`page-next${testIdSuffix}`}><ChevronRight size={14} /></Button>
      </div>
    </div>
  );
}
